import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Input } from '@/components/ui/input';
    import type { HTMLAttributes } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CreditCardInput',
  props: /*@__PURE__*/_mergeModels({
    placeholder: {},
    class: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

    

    const model = _useModel<string | null>(__props, "modelValue");

    const formatCreditCardNumber = (event: Event) => {
        const target = event.target as HTMLInputElement;
        let value = target.value.replace(/\s/g, ''); // Remove all spaces
        value = value.replace(/[^\d*]/g, ''); // Allow digits and * characters only
        value = value.substring(0, 19); // Limit to 16 characters (excluding spaces)

        // Add space after every 4 characters (digits or *)
        const formatted = value.replace(/([0-9*]{4})(?=[0-9*])/g, '$1 ');

        // Update both the input value and the form data
        target.value = formatted;
        value = formatted;
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Input), {
    id: "number",
    modelValue: model.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
    maxlength: "19",
    placeholder: "1234 1234 1234 1234",
    onInput: formatCreditCardNumber
  }, null, 8, ["modelValue"]))
}
}

})